import { type IntlShape } from 'react-intl'

export const formatPromotionFee = (intl: IntlShape, fee: number | undefined) =>
  fee === undefined
    ? intl.formatMessage({ id: 'promotions.shop.card.noFee' })
    : intl.formatNumber(fee, {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
      })
